export const environment = {
  production: true,
  apiUrl: 'https://api-pos.iria.co.id/v1/',
  //baseUrl :'https://pos.iria.co.id/',
  backOfficeUrl: 'https://api-pos.iria.co.id/',
  //apiUrl: 'http://localhost:8001/v1/',
  //backOfficeUrl: 'http://localhost:8001/',
  //baseUrl :'http://localhost:8100/',
  waApi : 'https://wab.vci.co.id/',
  kpiApi : 'https://kpi.vci.co.id/',
  //apiUrl: 'http://192.168.0.136:8001/v1/',
  //backOfficeUrl: 'http://192.168.0.136:8001',
  baseUrl :'http://192.168.0.136:8100/',
  myKey :'Wno-27082024',
  //baseUrl: 'http://192.168.0.44:8087/',
  //apiUrl:'http://192.168.0.44:8086/v1/'
};